import * as moment from 'moment';

export function customDateFormat(d, i, interval) {
  let month = moment(d).format('MMM'),
    short_month = moment(d).format('MMMM'),
    day = moment(d).format('D');

  if (i % interval == 0) {
    if (short_month.length > 4) return `${month}. ${day}`;
    else if (short_month.length <= 4) return `${short_month} ${day}`;
    else return '';
  }
}

// export function customDateEmbedFormat(d, startDate, endDate) {
//   let month = moment(d).format('MMM'),
//     short_month = moment(d).format('MMMM'),
//     day = moment(d).format('D');

//   if (moment(d).isSame(startDate) || moment(d).isSame(endDate)) {
//     if (short_month.length > 4) return `${month}. ${day}`;
//     else if (short_month.length <= 4) return `${short_month} ${day}`;
//     else return '';
//   }
// }

export function customPercentFormat(d, i, interval) {
  if (d === 0 || i % interval == 0) return '';
  else return `${d}%`;
}

// format date
export function apDateFormatMoment(d) {
  let month = moment(d).format('MMM'),
    short_month = moment(d).format('MMMM'),
    day = moment(d).format('D');

  if (short_month.length > 4) return `${month}. ${day}`;
  else if (short_month.length <= 4) return `${short_month} ${day}`;
}

// format percent
export function apPercentFormat(number) {
  let percent = Math.round(number * 1000) / 10;
  return percent + '%';
}
